import _default from './Confirm';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/Confirm/index.js
// module id = 1535
// module chunks = 0